<template>
    <div class="p-6 bg-red-900 min-h-screen flex justify-center items-center">
    <div class="w-full max-w-md">
      <logo />
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="reset">
        <div class="px-10 py-12">
          <h1 class="text-center font-bold text-3xl">Resetear Contraseña</h1>
          <div class="mx-auto mt-6 w-24 border-b-2" />
          <text-input v-model="form.email" :error="form.errors.email" class="mt-10" label="Email" autofocus autocapitalize="off" />
        </div>
        <div class="px-10 py-4 bg-gray-100 border-t border-gray-100 flex">
            <loading-button :loading="form.processing" class="btn-login" type="submit">Enviar link reseteo contraseña</loading-button>
            <Link href="/login" class="ml-auto btn-register font-bold text-black" method="get" aria-label="Cancelar">Cancelar</Link>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { Link } from '@inertiajs/inertia-vue'
import AccordionItem from '../../Shared/AccordionItem'

export default {
  metaInfo: { title: 'Reset Pass' },
  components: {
    AccordionItem,
    LoadingButton,
    Logo,
    TextInput,
    Link,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: '', //'johndoe@example.com',
      }),

    }
  },
  watch:{
        '$page.props.flash.success':function(newError, oldError){
            this.$alert(newError, 'Aviso.', {
                confirmButtonText: 'OK'
            });
        },
  },
  methods: {
    reset() {
      this.form.post(this.route('forget.password.post'))
    }
  },
}
</script>